/*
 * Main.ts
 * Description: Includes the declaration of Vue and
 * its main configuration
 */

// ================= Importing files =================

// Importing Vue
import Vue from 'vue';
// Importing the main base component
import App from './App.vue';
// Importing service workers
import './registerServiceWorker';
// Importing plugin configuration
import './config/plugins';
// Importing router and store config
import {router, store} from '@/config/plugins';

// ================= Vue =================

// Turning off production tip
Vue.config.productionTip = false;

// Initializing Vue
new Vue({
  render: (h) => h(App),
  store,
  router,
}).$mount('#app');
